// WordPress site URL codes -> booking store names (stores table).
export const AIRPORT_TO_STORE_NAME = {
  SYD: 'Sydney International Airport',
  MEL: 'Mel International Airport',
  AKL: 'Auckland International Airport'
}

// Optional terminal-specific overrides: 'AIRPORT:TERMINAL' -> store name
export const TERMINAL_OVERRIDES = {
  'MEL:T2': 'Melbourne International Airport'
}



// WEBPACK FOOTER //
// ./src/constants/wpStoreMapping.js